<template>
	<div>
		<!-- Banner Image -->
		<img
			class="banner-image"
			src="../assets/images/bts-membership-banner.jpg"
		/>

		<!-- Application Form -->
		<!-- TODO: Add - errors to scope slot and iterate error in errors near submit button to guide the user -->
		<ValidationObserver ref="observer" v-slot="{ invalid, validate }">
			<section class="section">
				<div class="container">
					<!-- Selected MemberType Notification -->
					<SelectedMemberNotification
						:selectedMemberType="applicationData.fields.selectedMemberType"
					/>

					<b-steps>
						<!-- Membership Levels Step -->
						<b-step-item label="Membership Levels" icon="account-cog">
							<b-message type="is-primary" title="Please Note:" closable>
								<p>
									Members of an affiliated organisation (BLTG, Carell Club,
									SOTPA) can specify this option at the next stage and receive a
									50% discount on the pricing shown below.
								</p>
								<br />
								<p>
									<strong
										>Please click select your chosen 'Member Type' and use the
										arrows at the bottom of the page to continue</strong
									>
								</p>
							</b-message>

							<!-- Membership Types -->
							<div class="columns is-multiline has-text-centered">
								<div
									class="column is-4"
									v-for="(memberType, index) in availableMembershipTypes"
									:key="index"
								>
									<MemberTypeCard
										:img="`${memberType.imageName}-membership.png`"
									>
										<template v-slot:content>
											<p>
												<b>NHS Medical:</b>
												{{ memberType.nhsMedical }}
											</p>
											<p>
												<b>Non Clinical Scientist:</b>
												{{ memberType.nonClinical }}
											</p>
											<p>
												<b>NHS:</b>
												{{ memberType.nhs }}
											</p>
											<p class="has-text-primary">
												<b>{{ memberType.price }}</b>
												<i> per Year.</i>
											</p>
											<p>Membership expires annually on 31st October.</p>
										</template>
										<template v-slot:footer>
											<a
												class="card-footer-item ksam-card-footer-item"
												@click="applyMemberCode(memberType)"
											>
												<b>SELECT</b>
											</a>
										</template>
									</MemberTypeCard>
								</div>
							</div>
						</b-step-item>

						<!-- Personal Information Step -->
						<b-step-item label="Personal Information" icon="account">
							<div class="columns is-multiline">
								<div class="column is-12">
									<BSelectWithValidation
										rules="required"
										label="Title"
										icon="format-title"
										placeholder="Please Select a Title"
										v-model="applicationData.fields.title"
									>
										<option
											v-for="(title, index) in titles"
											:key="index"
											:value="title"
										>
											{{ title }}
										</option>
									</BSelectWithValidation>
								</div>
								<div class="column is-6">
									<BInputWithValidation
										rules="required"
										label="First Name"
										placeholder="First Name"
										icon="account"
										v-model="applicationData.fields.firstName"
									/>
								</div>
								<div class="column is-6">
									<BInputWithValidation
										rules="required"
										label="Last Name"
										placeholder="Last Name"
										icon="account"
										v-model="applicationData.fields.lastName"
									/>
								</div>
								<div class="column is-6">
									<BInputWithValidation
										rules="required"
										label="Job Title"
										placeholder="Job Title"
										icon="account-group"
										v-model="applicationData.fields.jobTitle"
									/>
								</div>
								<div class="column is-6">
									<BInputWithValidation
										rules="required"
										label="Company"
										placeholder="Company"
										icon="account-group"
										v-model="applicationData.fields.company"
									/>
								</div>

								<div class="column is-6">
									<BInputWithValidation
										rules="required|numeric"
										label="Phone Number"
										placeholder="Phone Number"
										icon="phone"
										v-model="applicationData.fields.phoneNumber"
									/>
								</div>
								<div class="column is-6">
									<BInputWithValidation
										rules="required|email"
										label="Email Address"
										placeholder="example@example.com"
										icon="email"
										v-model="applicationData.fields.email"
									/>
								</div>

								<!-- UserName Notification -->
								<div class="column is-12">
									<b-message>
										<b>Please Note:</b> your Email Address is used as your
										'Username', when first logging in please select 'Forgotten
										Password' to finish setting up your account
									</b-message>
								</div>

								<div class="column is-6">
									<BSelectWithValidation
										rules="required"
										label="Field of Work"
										icon="briefcase"
										placeholder="Please Select a Field"
										expanded
										multiple
										v-model="applicationData.fields.fieldsOfWork"
									>
										<option
											v-for="(field, index) in fieldsOfWork"
											:key="index"
											:value="field.code"
										>
											{{ field.desc }}
										</option>
									</BSelectWithValidation>
									<div>
										<p class="has-text-primary is-italic">
											You may select multiple options by 'Control-Click'
											(Windows) or 'Command-Click' (Mac)
										</p>
										<p></p>
									</div>
								</div>

								<div class="column is-6">
									<BSelectWithValidation
										label="Affiliated Organisation"
										icon="briefcase"
										placeholder="Affiliated Organisation"
										expanded
										v-model="applicationData.fields.affiliatedOrganization"
									>
										<option
											v-for="(org, index) in affiliatedOrganizations"
											:key="index"
											:value="org.code"
										>
											{{ org.desc }}
										</option>
									</BSelectWithValidation>
									<span class="is-size-7 has-text-grey">
										Members of affiliated organisations are entitled to a 50%
										reduction in fees.
									</span>
								</div>

								<div class="column is-12 has-text-centered">
									<h1 class="title">
										Address Details
									</h1>
								</div>

								<!-- Address Tabs -->
								<b-tabs type="is-toggle" expanded>
									<!-- Home Address -->
									<b-tab-item label="Home Address" icon="home">
										<div class="columns is-multiline">
											<div class="column is-6">
												<BInputWithValidation
													rules="required"
													label="Home Address 1"
													placeholder="Address 1"
													icon="map-marker"
													v-model="applicationData.fields.homeAddress.address1"
												/>
											</div>
											<div class="column is-6">
												<BInputWithValidation
													rules="required"
													label="Home Address 2"
													placeholder="Address 2"
													icon="map-marker"
													v-model="applicationData.fields.homeAddress.address2"
												/>
											</div>

											<div class="column is-6">
												<BInputWithValidation
													rules="required"
													label="Home Address 3"
													placeholder="Address 3"
													icon="map-marker"
													v-model="applicationData.fields.homeAddress.address3"
												/>
											</div>
											<div class="column is-6">
												<BInputWithValidation
													rules="required"
													label="Home City"
													placeholder="City"
													icon="map-marker"
													v-model="applicationData.fields.homeAddress.city"
												/>
											</div>

											<div class="column is-6">
												<BSelectWithValidation
													rules="required"
													label="Home County"
													icon="map-marker"
													placeholder="Please Select a County"
													v-model="applicationData.fields.homeAddress.county"
													expanded
												>
													<option
														v-for="(county, index) in counties"
														:key="index"
														:value="county.code"
													>
														{{ county.desc }}
													</option>
												</BSelectWithValidation>
											</div>
											<div class="column is-6">
												<BInputWithValidation
													rules="required"
													label="Home Post Code"
													placeholder="Post Code"
													icon="map-marker"
													v-model="applicationData.fields.homeAddress.postCode"
												/>
											</div>
											<div class="column is-6">
												<BSelectWithValidation
													rules="required"
													label="Home Country"
													icon="map-marker"
													placeholder="Please Select a Country"
													v-model="applicationData.fields.homeAddress.country"
													expanded
												>
													<option
														v-for="(country, index) in countries"
														:key="index"
														:value="country.code"
													>
														{{ country.desc }}
													</option>
												</BSelectWithValidation>
											</div>
											<div class="column is-6"></div>
										</div>
									</b-tab-item>

									<!-- Work Address -->
									<b-tab-item label="Work Address" icon="home-city">
										<div class="columns is-multiline">
											<div class="column is-6">
												<BInputWithValidation
													rules="required"
													label="Work Address 1"
													placeholder="Address 1"
													icon="map-marker"
													v-model="applicationData.fields.workAddress.address1"
												/>
											</div>
											<div class="column is-6">
												<BInputWithValidation
													rules="required"
													label="Work Address 2"
													placeholder="Address 2"
													icon="map-marker"
													v-model="applicationData.fields.workAddress.address2"
												/>
											</div>

											<div class="column is-6">
												<BInputWithValidation
													rules="required"
													label="Work Address 3"
													placeholder="Address 3"
													icon="map-marker"
													v-model="applicationData.fields.workAddress.address3"
												/>
											</div>
											<div class="column is-6">
												<BInputWithValidation
													rules="required"
													label="Work City"
													placeholder="City"
													icon="map-marker"
													v-model="applicationData.fields.workAddress.city"
												/>
											</div>

											<div class="column is-6">
												<BSelectWithValidation
													rules="required"
													label="Work County"
													icon="map-marker"
													placeholder="Please Select a County"
													v-model="applicationData.fields.workAddress.county"
													expanded
												>
													<option
														v-for="(county, index) in counties"
														:key="index"
														:value="county.code"
													>
														{{ county.desc }}
													</option>
												</BSelectWithValidation>
											</div>
											<div class="column is-6">
												<BInputWithValidation
													rules="required"
													label="Work Post Code"
													placeholder="Post Code"
													icon="map-marker"
													v-model="applicationData.fields.workAddress.postCode"
												/>
											</div>
											<div class="column is-6">
												<BSelectWithValidation
													rules="required"
													label="Work Country"
													icon="map-marker"
													placeholder="Please Select a Country"
													v-model="applicationData.fields.workAddress.country"
													expanded
												>
													<option
														v-for="(country, index) in countries"
														:key="index"
														:value="country.code"
													>
														{{ country.desc }}
													</option>
												</BSelectWithValidation>
											</div>
											<div class="column is-6"></div>
										</div>
									</b-tab-item>
								</b-tabs>

								<!-- Address Preferences -->
								<div class="column is-12 has-text-centered">
									<h1 class="title">
										Address Preferences
									</h1>
								</div>
								<div class="column is-6">
									<BSelectWithValidation
										rules="required"
										label="Preferred Billing Address"
										icon="cash"
										placeholder="Preferred Billing Address"
										expanded
										mobile-native="false"
										v-model="applicationData.fields.preferredBilling"
									>
										<option value="home">Home</option>
										<option value="work">Work</option>
									</BSelectWithValidation>
								</div>
								<div class="column is-6">
									<BSelectWithValidation
										rules="required"
										label="Preferred Mailing Address"
										icon="post"
										placeholder="Preferred Mailing Address"
										expanded
										v-model="applicationData.fields.preferredMailing"
									>
										<option value="home">Home</option>
										<option value="work">Work</option>
									</BSelectWithValidation>
								</div>
							</div>
						</b-step-item>

						<!-- Supporter Information Step -->
						<b-step-item
							label="Supporter Information"
							icon="account-supervisor"
						>
							<div class="columns">
								<div class="column is-6">
									<BInputWithValidation
										rules="required"
										label="First Supporter BTS Membership Number"
										placeholder="First Supporter BTS Membership Number"
										icon="numeric-1"
										v-model="applicationData.fields.firstSupporter"
									/>
								</div>
								<div class="column is-6">
									<BInputWithValidation
										rules="required"
										label="Second Supporter BTS Membership Number"
										placeholder="Second Supporter BTS Membership Number"
										icon="numeric-2"
										v-model="applicationData.fields.secondSupporter"
									/>
								</div>
							</div>
							<div class="columns">
								<div class="column is-12">
									<b-notification
										type="is-info"
										aria-close-label="Close notification"
									>
										<p>
											If you're unsure of your 'Supporters' Membership Number,
											please ask them.
										</p>
										<p>
											Alternatively, you can get in touch with us at
											<a href="mailto:secratariat@bts.org.uk"
												>secretariat@bts.org.uk</a
											>
											and we will help you locate these.
										</p>
									</b-notification>
								</div>
							</div>
						</b-step-item>

						<!-- Terms and Conditions Step -->
						<b-step-item label="Terms &amp; Conditions" icon="file-question">
							<div class="columns is-multiline">
								<div class="column is-12 has-text-centered">
									<h1 class="title">Terms &amp; Conditions</h1>
								</div>
								<div class="column is-12">
									<TermsAndConditions :terms-accepted="termsAccepted" />
								</div>
								<div class="column is-6"></div>
								<div class="column is-12">
									<div class="buttons">
										<b-button
											type="is-primary"
											:disabled="termsAccepted"
											@click="acceptTerms"
											>Accept Terms & Conditions</b-button
										>
										<b-button
											type="is-primary"
											@click="validate().then(submit)"
											:disabled="
												invalid ||
													termsAccepted === false ||
													!applicationData.fields.memberCode
											"
										>
											Submit Application
										</b-button>
									</div>
									<div class="column is-12">
										<span class="is-size-7 has-text-grey">
											Please ensure you have 'Accepted' the Terms &amp;
											conditions and have completed all required fields with no
											errors prior to submitting.
										</span>
									</div>
								</div>
							</div>
						</b-step-item>
					</b-steps>
				</div>
			</section>
		</ValidationObserver>
	</div>
</template>

<script>
import MemberTypeCard from '../components/MemberTypeCard';
import SelectedMemberNotification from '../components/SelectedMemberNotification';
import TermsAndConditions from '../components/TermsAndConditions';

// VeeValidate
import { ValidationObserver } from 'vee-validate';

// Axios
import axios from 'axios';
import qs from 'qs';

// Inputs with PreBuilt Validation Provider from VeeValidate
import BInputWithValidation from '../components/inputs/BInputWithValidation';
import BSelectWithValidation from '../components/inputs/BSelectWithValidation';

// Lodash (for Debounce) [Could do with importing just debounce but v5 removes per method packages]
// import _ from 'lodash';

export default {
	name: 'ApplicationForm',

	components: {
		MemberTypeCard,
		SelectedMemberNotification,
		TermsAndConditions,
		ValidationObserver,
		BInputWithValidation,
		BSelectWithValidation,
	},

	data() {
		return {
			availableMembershipTypes: [
				{
					type: 'Reduced',
					imageName: 'reduced',
					nhsMedical: 'Student',
					nonClinical: 'Scientist',
					nhs: 'Band 7 and Below',
					price: '£40.00',
					memberCode: 'RM',
				},
				{
					type: 'Ordinary',
					imageName: 'ordinary',
					nhsMedical: 'SPR',
					nonClinical: 'Lecturer',
					nhs: 'Band 8a, 8b or 8c',
					price: '£105.00',
					memberCode: 'OM',
				},
				{
					type: 'Consultant',
					imageName: 'consultant',
					nhsMedical: 'Consultant',
					nonClinical: 'Senior Lecturer, Reader, Professor',
					nhs: 'Band 8d or above',
					price: '£150.00',
					memberCode: 'CM',
				},
			],

			titles: [],
			countries: [],
			counties: [],
			fieldsOfWork: [],
			affiliatedOrganizations: [],

			applicationData: {
				fields: {
					selectedMemberType: null,
					fieldsOfWork: [],
					homeAddress: {},
					workAddress: {},
				},
			},

			termsAccepted: false,

			formErrors: {
				errors: [],
				warnings: [],
			},
		};
	},

	created() {
		this.getApplicationFormData();
	},

	methods: {
		async submit() {
			//TODO: These Member checks need to be way more graceful
			// Check Member Number 1
			const { data: supporterOneCheck } = await axios.get(
				`https://i20api.ksam.co.uk/bts/check-supporter/${this.applicationData.fields.firstSupporter}`
			);

			// Check Member Number 2
			const { data: supporterTwoCheck } = await axios.get(
				`https://i20api.ksam.co.uk/bts/check-supporter/${this.applicationData.fields.secondSupporter}`
			);

			// If neither member number is found

			if (supporterOneCheck.Count < 1 && supporterTwoCheck.Count < 1) {
				this.$refs.observer.setErrors({
					'First Supporter Membership Number':
						'This Membership Number does not seem to exist.',
					'Second Supporter Membership Number':
						'This Membership Number does not seem to exist.',
				});

				this.$buefy.toast.open({
					duration: 3000,
					message: 'Supporter Number 1 & 2 does not seem to exist!',
					type: 'is-danger',
				});
			}

			// If only member number 1 isn't found
			if (supporterOneCheck.Count < 1) {
				this.$refs.observer.setErrors({
					'First Supporter Membership Number':
						'This Membership Number does not seem to exist.',
				});

				this.$buefy.toast.open({
					duration: 3000,
					message: 'Supporter Number 1 does not seem to exist!',
					type: 'is-danger',
				});
				return;
			}

			// If only member number 2 isn't found
			if (supporterTwoCheck.Count < 1) {
				this.$refs.observer.setErrors({
					'Second Supporter Membership Number':
						'This Membership Number does not seem to exist.',
				});

				this.$buefy.toast.open({
					duration: 3000,
					message: 'Supporter Number 2 does not seem to exist!',
					type: 'is-danger',
				});

				return;
			}

			const response = await axios.post(
				'https://i20api.ksam.co.uk/bts/application-form',
				qs.stringify(this.applicationData)
			);

			if (response.data.Errors || response.data.Warnings) {
				response.data.Errors.$values.forEach((val) => {
					this.formErrors.errors.push(val);
				});

				response.data.Warnings.$values.forEach((val) => {
					this.formErrors.warnings.push(val);
				});
			} else {
				this.$router.push(`/confirmation?name=${response.data.fullName}`);
			}
		},

		async getApplicationFormData() {
			const { data } = await axios.get(
				'https://i20api.ksam.co.uk/bts/application-form'
			);
			this.titles = data.titles;
			this.countries = data.countries;
			this.counties = data.counties;
			this.fieldsOfWork = data.fieldsOfWork;
			this.affiliatedOrganizations = data.affiliatedOrganizations;
		},

		acceptTerms() {
			this.termsAccepted = !this.termsAccepted;
			this.$buefy.toast.open({
				duration: 3000,
				message: 'Thankyou for Accepting the Terms & Conditions',
				type: 'is-success',
			});
		},

		applyMemberCode(memberType) {
			this.applicationData.fields.selectedMemberType = memberType.type;
			this.applicationData.fields.memberCode = memberType.memberCode;
		},
	},
};
</script>

<style>
.step-navigation {
	text-align: center;
}
</style>
